import Vue from "vue";
import Router from "vue-router";
import routes from "./routes/routes";

Vue.use(Router);

// configure router
export default new Router({
  mode: "history",
  routes,
  linkExactActiveClass: "nav-item active",
  scrollBehavior(to) {
    const position = { x: 0, y: 0 };
    if (to.matched.some(m => m.meta.retainScrollPosition)) {
      return false;
    } else {
      document.getElementById("main-panel").scrollTop = 0;
      return position;
    }
  }
});
